







































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Choices, { Choice } from "@/store/modules/Choices";
import { Urls } from '@/Urls';
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import { NotificationEventBus } from "@/EventBus";
import ListInputDialog from "@/components/forms/ListInputDialog.vue";
import Decisions from "@/store/modules/Decisions";
import ChoiceFileImporter from "@/views/ChoiceImport/ChoiceFileImporter.vue";
import BasicInputForm from "@/components/forms/BasicInputForm.vue";
import _ from "lodash";
import ChoiceMappingTables from "@/views/ChoiceImport/ChoiceMappingTables.vue";
import Users from "@/store/modules/Users";

const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const choicesModule = getModule(Choices);

@Component({
    components: {ListInputDialog, ConfirmationDialog, ChoiceFileImporter, BasicInputForm}
})
export default class ChoiceNavigation extends Vue {

    @Prop({default: false, type: Boolean})
    menuVisible!: boolean;

    @Prop({default: false, type: Boolean})
    menuEdit!: boolean;

    @Prop({default: false, type: Boolean})
    menuNew!: boolean;

    @Prop({default: false, type: Boolean})
    menuFolderToggle!: boolean;

    @Prop({default: '', type: String})
    clickUrl!: string;

    @Prop({default: 'Select a Choice', type: String})
    header!: string;

    private readonly URLS = Urls;
    private openValues: any[] = [];
    private menuShow: boolean = false;
    private refreshing = false;
    private cloneChoiceDialog = false;
    private originalChoice: any = {};
    private deleteMode = false;
    private deleteList = [];

    get selectedDecision() {
        this.deleteMode = false;
        this.deleteList = []
        return decisionsModule.selectedDecision;
    }

    // Get the values to display which one is selected in the tree
    get activeItems(): any[] {
        if (this.selectedChoice) {
            return [this.selectedChoice];
        }
        return [];
    }

    // When this value gets changed we need to update the module so that it reflects the selected value on all views
    set activeItems(treeItems: any[]) {
    }

    get selectedChoice() {
        // Passing a default object with id: -1 to satisfy a dynamic CSS rule on the "label" slot above
        return choicesModule.selectedChoice || {id: ''};
    }

    get activeChoiceLists() {
        return workspaceOptionsModule.activeChoiceLists || []
    }

    get choicesList() {
        let usersModule = getModule(Users)
        let currentId = usersModule.currentUserProfile?.userId
        let owner = this.selectedDecision.ownerUserId
        let choicesListClone = _.cloneDeep(choicesModule.choicesList)
        return choicesListClone.map(choice => { choice.blockDelete = ![choice.ownerUserId, owner].includes(currentId) && ['VIEW', 'EDIT'].includes(choice.shareSetting); return choice});
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel
    }

    get choices(): any[] {
        let res: any = [{
            id: 'ROOT',
            name: this.pluralChoiceLabel ? this.pluralChoiceLabel: "Choices",
            children: this.choicesList
        }];
        return res;
    }

    get visibilityMap() {
        return workspaceOptionsModule.choiceVisibility;
    }

    private async refreshChoices() {
        this.refreshing = true;
        await choicesModule.fetchChoices()
        this.refreshing = false;
    }

    private createNewChoice() {
        choicesModule.selectChoice(null);
        this.navigateToChoiceUpdate();
    }

    private async selectChoice(itemId: string) {
        if (itemId) {
            await choicesModule.selectChoice(itemId);
        }
    }

    private editChoice(itemId: string) {
        if (itemId) {
            choicesModule.selectChoice(itemId);
            this.navigateToChoiceUpdate();
        }
    }

    private navigateToChoiceUpdate() {
        if (this.$router.currentRoute.path !== Urls.CHOICE_SUBMITTER) {
            this.$router.push({path:Urls.CHOICE_SUBMITTER,query: this.$router.currentRoute.query} );
        }
    }

    private async deleteChoice(choiceId: string) {
        NotificationEventBus.emitProcessingMessage();
        try {
            await choicesModule.deleteChoice(choiceId);
            NotificationEventBus.emitSuccessMessage();
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e);
        }
    }

    private updateVisibility(choiceId: string, value: any) {
        workspaceOptionsModule.changeChoiceVisibility({id: choiceId, value: value});
    }

    private async submit(payload: any) {
        let list = payload.names;
        let addToList = _.clone(payload.addToList)
        if (list.length) {
            let choices = list.filter(l => l)
                .map(name => {
                    return {
                        name: name
                    } as Choice
                })
            this.refreshing = true;
            let newChoices = await choicesModule.createChoices(choices)
            if(addToList && newChoices) {
                for(let choice of Object.values(newChoices)) {
                    decisionsModule.addChoiceToActiveLists(choice.id)

                }
            }
            this.refreshing = false;
        }
    }

    private async copyChoice(choice: any) {
        this.cloneChoiceDialog = false;
        await choicesModule.copyChoice({choice: this.originalChoice, newChoiceParams: choice})
    }

    private async deleteMultiple() {
        if(!this.deleteMode) {
            this.deleteMode = !this.deleteMode
            return
        }

        else {
            if(this.deleteList.length > 0) {
                await choicesModule.deleteMultiple(this.deleteList)
            
                if(workspaceOptionsModule.activeChoiceLists.length > 0) {
                    await decisionsModule.deleteChoiceFromList()
                }
            }
            this.deleteList = [];
            this.deleteMode = false;
            return
        }
    }

    private canUserDelete(choice: any) {
        let usersModule = getModule(Users)

        //Owner of decision can always delete choices
        if(decisionsModule.selectedDecision.ownerUserId === usersModule.currentUserProfile.userId) {
            return true
        }

        if(choice.ownerUserId === usersModule.currentUserProfile.userId) {
            return true
        }

        if(decisionsModule.isAdmin) {
            return true;
        }

        //Reaching here means user is not owner of choice or decision
        return !["VIEW", "EDIT"].includes(choice.shareSetting)

    }


}

